import { showImagePreview } from 'vant';
export default {
  props: {
    srcs: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    srcArrays() {
      return this.srcs.map(src => ({
        src,
        key: new Date().getTime() + Math.random()
      }));
    }
  },
  methods: {
    handlePreview(images, image) {
      const startPosition = images.findIndex(url => url === image);
      showImagePreview({
        images,
        startPosition
      });
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};